import { Toaster, Position } from "@blueprintjs/core";

// export const BASE_API = "https://d1-worker.cosminnastasie.workers.dev";
export const BASE_API = "https://api.fotbalmanager.com";

export const startChampionshipDate = '2025-08-29'

// export const LOGIN_REDIRECT = {
//     'superadmin': 'superadmin',
//     'admin': '/admin',
//     'coach': '/dashboard',
//     'viewer': '/viewdashboard',
// };

export const LOGIN_REDIRECT = {
  superadmin: "/superadmin",
  admin: "/admin/echipe",
  coach: "/dashboard/players",
  viewer: "/dashboard/players",
};

export const SUPERADMIN_ORG_SLUG = "superadmin-org";

export const AppToaster = Toaster.create({
  position: Position.TOP,
});

// submenus.js (sau în același fișier)
export const SUBMENUS = {
  superadmin: ["Organizații", "Admins",
    //  "Setări"
  ],
  superadmin: [
    "Echipe",
    // "Users",
    "Antrenori",
    // "Viewers",  
    //, "Setări"
  ],
  coach: [
    'Jucatori',
    'Calendar',
    // 'Antrenamente',
    // 'Jocuri',
  ],
  team: ["Jucători",
    //  "Jocuri", 
     "Calendar"],
  training: ["Exerciții", "Prezență", "Încărcare"],
  default: []
};

export const SUBMENU = {
  /* ─────────────────  SUPERADMIN  ───────────────── */
  superadmin: [
    { key: "clubs", slug: "organizatii", label: "Organizații", icon: "" },
    { key: "admins", slug: "admins", label: "Admins", icon: "" },
  ],

  /* ────────────────────  ADMIN  ─────────────────── */
  admin: [
    { key: "teams", slug: "echipe", label: "Echipe", icon: "" },
    { key: "coaches", slug: "antrenori", label: "Antrenori", icon: "" },
  ],

  /* ────────────────────  COACH  ─────────────────── */
  coach: [
    { key: "dashboard_coach", slug: "dashboard", label: "Dashboard", icon: "" },
    // { key: "calendar",   slug: "calendar",      label: "Calendar",      icon: "" },
    // { key: "players",    slug: "jucatori",      label: "Jucători",      icon: "/icons/player-icon.png" },
    // { key: "training",  slug: "antrenament",  label: "Antrenament",  icon: "" },
    // { key: "games",      slug: "jocuri",        label: "Jocuri",        icon: "" },
  ],

  // Dashboard de echipă (rol coach)
  echipa: [                              // ← nouă cheie-rol
    { key: "dashboard",  slug: "dashboard",     label: "Dashboard",     icon: "" },
    { key: "calendar", slug: "calendar", label: "Calendar", icon: "" },
    { key: "players", slug: "jucatori", label: "Jucători", icon: "/icons/player-icon.png" },
    { key: "analitycs", slug: "analitycs", label: "Analitics", icon: "" },

    // { key: "training", slug: "antrenament", label: "Antrenament", icon: "" },
    // { key: "games", slug: "jocuri", label: "Jocuri", icon: "" },
    // { key: "trainings", slug: "antrenamente", label: "Antrenamente", icon: "" },

  ],
};


export const COLORS = ["red", "green", "orange", "darkcyan", "darkturquoise", "#009688", 'orangered', '#5d8aa8', 'yellow'];

export const PLAYER_POSITIONS = [
  { code: "GK", label: "1. Portar (GK)", number: 1 },
  { code: "FD", label: "2. Fundaș Dreapta (FD)", number: 2 },
  { code: "FS", label: "3. Fundaș Stânga (FS)", number: 3 },
  { code: "FCD", label: "4. Fundaș Central Dreapta (FCD)", number: 4 },
  { code: "FCS", label: "5. Fundaș Central Stânga (FCS)", number: 5 },
  { code: "MC", label: "6. Mijlocaș Central (MC)", number: 6 },
  { code: "ID", label: "8. Inter Dreapta (ID)", number: 8 },
  { code: "IS", label: "10. Inter Stânga (IS)", number: 10 },
  { code: "AD", label: "7. Atacant Dreapta (AD)", number: 7 },
  { code: "AS", label: "11. Atacant Stânga (AS)", number: 11 },
  { code: "AC", label: "9. Atacant Central (AC)", number: 9 },
];

export const PLAYERS_STATUS = [
  { key: 'accidentat', icon: 'plus' },
  { key: 'suspendat', icon: 'blocked-person' },
  { key: 'active', icon: 'tick' },
  { key: 'inactive', icon: 'cross' }
]

export const PLAYERS_TRAINING_STATUS = [
  { key: 'active', name: 'active', icon: 'tick' },
  { key: 'accidentat', name: 'accidentat', icon: 'plus' },
  // { key: 'suspendat', name:  'suspendat', icon: 'blocked-person'},
  { key: 'absent', name: 'absent', icon: 'ban-circle' },
  { key: 'invoit', name: 'invoit', icon: 'endorsed' },
  { key: 'neconvocat', name: 'neconvocat', icon: 'minus' },
]

export const HOME_AWAY = [
  { id: "acasa", name: "Acasă" },
  { id: "deplasare", name: "Deplasare" }
];

export const GAME_TYPES = [
  { id: "amical", name: "Amical" },
  { id: "campionat", name: "Campionat" },
  { id: "cupa", name: "Cupă" }
];